import React from 'react';

const AdminContext = React.createContext();
export const AdminProvider = AdminContext.Provider;
export default AdminContext;